import Home from './pages/home'
import HomeIcon from '@material-ui/icons/Home'

import ProductsPage from './pages/products'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'

import SubscriptionPacksPage from './pages/subscription-packs'

import AdminPage from './pages/admin'
import AdminIcon from '@material-ui/icons/SettingsApplications'

import SimcardsPage from './pages/simcards'
import SdCardIcon from '@material-ui/icons/SdCard'

import SubscriptionsPage from './pages/subscriptions'
import RenewPage from './pages/subscriptions/renew'
import SubscriptionsIcon from '@material-ui/icons/Subscriptions'

import SubscriptionListPage from './pages/subscription-list'

import SubscriptionDetailsPage from './pages/subscription-details'

import LoginPage from './pages/account/login'
import LockIcon from '@material-ui/icons/Lock'

import RegisterPage from './pages/account/register'
import RegisteredPage from './pages/account/registered'
import SetPasswordPage from './pages/account/set-password'
import ForgotPasswordPage from './pages/account/forgot-password'
import ForgotPasswordEmailSentPage
  from './pages/account/forgot-password-mail-sent'

import SupportPage from './pages/support'
import ForumIcon from '@material-ui/icons/Forum'
import ProfilePage from './pages/account/profile'
import PersonIcon from '@material-ui/icons/Person'

import ExitToAppIcon from '@material-ui/icons/ExitToApp'

import UsersPage from './pages/users'
import PeopleIcon from '@material-ui/icons/People'

import PageTextsPage from './pages/page-texts'
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline'

import GdprPage from './pages/gdpr'
import FlagIcon from '@material-ui/icons/Flag'

import ContactPage from './pages/support/contact'

import ChangePasswordPage from './pages/account/change-password'

import TermsAndConditionsPage from './common/terms-and-conditions-page'
import PrivacyPolicyPage from './common/privacy-policy-page'

import TutorialsPage from './pages/support/tutorials'
import SchoolIcon from '@material-ui/icons/School'

import AppPage from './pages/app'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    iconComponent: HomeIcon,
    exact: true,
    show: false
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/registered',
    name: 'Registered',
    component: RegisteredPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/set-password/:ticketId',
    name: 'User password',
    component: SetPasswordPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPasswordPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/forgot-password-sent',
    name: 'Forgot Password Sent',
    component: ForgotPasswordEmailSentPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms and Conditions',
    component: TermsAndConditionsPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicyPage,
    iconComponent: LockIcon,
    exact: true,
    show: false
  }
]

export const publicMenuRoutes = [
  {
    path: '/tutorials',
    name: 'Tutorials',
    component: TutorialsPage,
    iconComponent: SchoolIcon,
    exact: true,
    show: true,
    public: true
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportPage,
    iconComponent: ForumIcon,
    exact: true,
    show: true
  },
  {
    path: '/contact-us',
    name: 'Contact us',
    component: ContactPage,
    iconComponent: ForumIcon,
    exact: true,
    show: false
  }
]

export const accountRoutes = [
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    iconComponent: PersonIcon,
    exact: true,
    show: true
  },
  {
    path: '/change-password',
    name: 'Change password',
    component: ChangePasswordPage,
    iconComponent: LockIcon,
    exact: true,
    show: true
  },
  {
    path: '/logout',
    name: 'Log out',
    component: null,
    iconComponent: ExitToAppIcon,
    exact: true,
    show: true
  }
]

export const userRoutes = [
  {
    path: '/subscriptions',
    name: 'My Subscriptions',
    component: SubscriptionsPage,
    iconComponent: SubscriptionsIcon,
    exact: true,
    show: true
  },
  {
    path: '/subscriptions/renew/:imsi',
    name: 'Renew',
    component: RenewPage,
    iconComponent: SubscriptionsIcon,
    exact: true,
    show: false
  }
]

export const adminRoutes = [
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    iconComponent: AdminIcon,
    exact: false,
    show: true
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsPage,
    iconComponent: ShoppingCartIcon,
    exact: false,
    show: true
  },
  {
    path: '/simcards',
    name: 'Simcards',
    component: SimcardsPage,
    iconComponent: SdCardIcon,
    exact: false,
    show: true
  },
  {
    path: '/subscription-details/:id',
    name: 'Subscription details',
    component: SubscriptionDetailsPage,
    iconComponent: SubscriptionsIcon,
    exact: true,
    show: false
  },
  {
    path: '/list-subscriptions',
    name: 'All subscriptions',
    component: SubscriptionListPage,
    iconComponent: SubscriptionsIcon,
    exact: true,
    show: true
  },
  {
    path: '/users',
    name: 'Users',
    component: UsersPage,
    iconComponent: PeopleIcon,
    exact: true,
    show: true
  },
  {
    path: '/pagetexts',
    name: 'Page texts',
    component: PageTextsPage,
    iconComponent: ViewHeadlineIcon,
    exact: true,
    show: true,
  },
  {
    path: '/gdpr',
    name: 'GDPR',
    component: GdprPage,
    iconComponent: FlagIcon,
    exact: true,
    show: true
  },
  {
    path: '/app',
    name: 'App',
    component: AppPage,
    iconComponent: FlagIcon,
    exact: true,
    show: false
  }
]

export const superAdminRoutes = [
  { 
    path: '/subscription-packs',
    name: 'subscription_packs_nav',
    component: SubscriptionPacksPage,
    iconComponent: SubscriptionsIcon,
    exact: true,
    show: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js